import { FC } from "react";
import { Col, Row, SelectProps, Space } from "antd";
import { GenericSelect } from "../../../../../common/GenericSelect";
import { QuarterCard, QuarterCardProps } from "./QuarterCard";
import classes from "./PeriodSelector.module.less";

interface PeriodSelectorProps {
    year?: SelectProps["value"];
    yearOptions?: SelectProps["options"];
    onYearChange?: SelectProps["onChange"];
    selectedQuarters?: number[];
    checkedQuarters?: number[];
    quarterOptions?: QuarterCardProps[];
    onQuarterSelect?: (quarter: number) => void;
    onQuarterToggle?: (quarter: number) => void;
    hideQuarters?: boolean;
}

export const PeriodSelector: FC<PeriodSelectorProps> = ({
    year,
    yearOptions,
    onYearChange,
    selectedQuarters = [],
    checkedQuarters = [],
    quarterOptions,
    onQuarterSelect,
    onQuarterToggle,
    hideQuarters,
}) => {
    return (
        <div>
            <Row gutter={8} align="middle">
                <Col flex={1}>
                    <GenericSelect
                        className={classes.select}
                        value={year}
                        options={yearOptions}
                        onChange={onYearChange}
                    />
                </Col>
            </Row>
            <Space direction="vertical" size={16} className={classes.quarters}>
                {hideQuarters ? (
                    <QuarterCard message="Select a specific year to view savings" />
                ) : (
                    quarterOptions?.map((option) => (
                        <QuarterCard
                            key={option.quarter}
                            {...option}
                            selected={selectedQuarters.includes(option.quarter || 1)}
                            checked={checkedQuarters.includes(option.quarter || 1)}
                            showCheckbox={
                                selectedQuarters.length > 1 ||
                                !selectedQuarters.includes(option.quarter || 1)
                            }
                            onSelect={onQuarterSelect}
                            onToggle={onQuarterToggle}
                        />
                    ))
                )}
            </Space>
        </div>
    );
};
